export const StatusShipment = [
  { Todos: 100, Label: "Todos" },
  { Creado: 6, Label: "Creado" },
  { Recibido: 7, Label: "Recibido" },
  { Documentado: 8, Label: "Documentado" },
  { En_Transito: 9, Label: "En transito" },
  { Entregado: 10, Label: "Entregado" },
  { No_Entregado: 16, Label: "No Entregado" },
];

export const Status = [
  { value: 1, label: "Todos" },
  { value: 2, label: "Activo" },
  { value: 3, label: "Inactivo" },
];
